import { Component, inject, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

import {
    LogicStepParameter,
    LogicStepParameterProperty,
} from '@wdx/shared/utils';
import { IWrappedWorkflowFormComponentProvider } from '../../../interfaces';
import { BehaviorSubject } from 'rxjs';
import {
    ActiveFieldState,
    RelativeDateStrategy,
    RelativePartyStrategy,
    SegmentedControlStrategyRegistry,
} from '../../../services';

@Component({
    selector: 'clmi-workflow-designer-parameter-segmented',
    templateUrl: './parameter-segmented.component.html',
    standalone: false,
    providers: [
        SegmentedControlStrategyRegistry,
        RelativeDateStrategy,
        RelativePartyStrategy,
    ],
})
export class WorkflowDesignerParameterSegmentedComponent implements OnInit {
    private readonly registry = inject(SegmentedControlStrategyRegistry);

    @Input() parameter!: LogicStepParameter;
    @Input() formGroup!: FormGroup;
    @Input() componentProvider?: IWrappedWorkflowFormComponentProvider;

    prefixParam$!: BehaviorSubject<LogicStepParameterProperty | null>;
    activeParams$!: BehaviorSubject<ActiveFieldState | null>;

    ngOnInit(): void {
        const strategy = this.registry.getStrategy(this.parameter.kind);
        strategy.init(this.parameter, this.formGroup);

        this.prefixParam$ = strategy.prefixParam$;
        this.activeParams$ = strategy.activeParams$;
    }
}
